import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PathList from "./PathList";
import LoginScreen from "../Screens/LoginScreen";
import Layout from "../Screens/Layout/Layout";
import Dashboard from "../Screens/Dashboard/Dashboard";
import UserManagement from "../Screens/UserManagement/UserManagement";
import { Middleware } from "../Config/MiddleWare";
import UserDetails from "../Screens/UserManagement/UserDetails";
import Notifications from "../Screens/NotificationManagement/Notifications";
import ReportUsers from "../Screens/ReportUsers/ReportUsers";
import ReportUserDetails from "../Screens/ReportUsers/ReportUserDetails";
import Feedbacks from "../Screens/Feedbacks/Feedbacks";
import HashtagManagement from "../Screens/HashtagManagement/HashtagManagement";
import FeedbacksModule from "../Screens/FeedbacksModule/Feedbacks";
import FAQs from "../Screens/FAQs/FAQs";
import CommentReasons from "../Screens/CommentReasons/CommentReasons";
import ReportedComments from "../Screens/ReportedComments/ReportedComments";
import StrikeManagement from "../Screens/StrikeManagement/StrikeManagement";

const RouteList = () => {
  return (
    <Routes>
      <Route path={PathList.Login} element={<LoginScreen />} />
      <Route
        path={PathList.Dashboard}
        element={<Middleware children={<Layout element={<Dashboard />} />} />}
      />
      <Route
        path={PathList.UserManagement}
        element={
          <Middleware children={<Layout element={<UserManagement />} />} />
        }
      />
      <Route
        path={PathList.UserDetails}
        element={<Middleware children={<Layout element={<UserDetails />} />} />}
      />
      {/* <Route
        path={PathList.ContentManagement}
        element={
          <Middleware children={<Layout element={<ContentManagement />} />} />
        }
      /> */}
      <Route
        path={PathList.NotificationManagement}
        element={
          <Middleware children={<Layout element={<Notifications />} />} />
        }
      />
      <Route
        path={PathList.ReportManagement}
        element={
          <Middleware children={<Layout element={<ReportUsers />} />} />
        }
      />
      <Route
        path={PathList.ReportUserDetails}
        element={
          <Middleware children={<Layout element={<ReportUserDetails />} />} />
        }
      />
      <Route
        path={PathList.feedbacks}
        element={
          <Middleware children={<Layout element={<Feedbacks />} />} />
        }
      />
      <Route
        path={PathList.HashtagManagement}
        element={
          <Middleware children={<Layout element={<HashtagManagement />} />} />
        }
      />
      <Route
        path={PathList.FeedbacksModule}
        element={
          <Middleware children={<Layout element={<FeedbacksModule />} />} />
        }
      />
      <Route
        path={PathList.FAQs}
        element={
          <Middleware children={<Layout element={<FAQs />} />} />
        }
      />
      <Route
        path={PathList.CommentReasons}
        element={
          <Middleware children={<Layout element={<CommentReasons />} />} />
        }
      />
      <Route
        path={PathList.ReportedComments}
        element={
          <Middleware children={<Layout element={<ReportedComments />} />} />
        }
      />
      <Route
        path={PathList.ReportedComments}
        element={
          <Middleware children={<Layout element={<ReportedComments />} />} />
        }
      />
      <Route
        path={PathList.Strike}
        element={
          <Middleware children={<Layout element={<StrikeManagement />} />} />
        }
      />
    </Routes>
  );
};

export default RouteList;
